var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-info-popup"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }